import axios from "axios";

// const http = axios.create({
//     baseURL: window.location.protocol + "//" + window.location.hostname + ":" + 9001,
//     headers: { "Content-type": "application/json", },
// });

// http.interceptors.response.use(
//     (response) => response,
//     (error) => {
//         console.log("httpError", error.code);
//         return Promise.reject(error);
//     }
// );

const host = window.location.hostname;

const apiService = {
    findUserByEmail(email) {
        return axios.post(`https://${host}:9001/api/findUserByEmail`, { email: email });
    },
    verifyOtp(email, otp) {
        return axios.post(`https://${host}:9001/api/verifyOtp`, { email: email, otp: otp });
    },
    confirmedAppv(series) {
        return axios.post(`https://${host}:9001/api/confirmedAppv`, {
            series: series
        });
    },
    confirmedENTCSAppv(series) {
        return axios.post(`https://${host}:9001/api/confirmedENTCSAppv`, {series: series});
    },
    finalApproval(series, approvalStatus, approvalMessage, rejectionMessage, approvalRole, approvalid) {
        return axios.post(`https://${host}:9001/api/finalApproval`, {
            series: series,
            approvalStatus: approvalStatus,
            approvalMessage: approvalMessage,
            rejectionMessage: rejectionMessage,
            approvalRole: approvalRole,
            approvalid: approvalid,
        });
    },
    finalEntCSApproval(series, approvalStatus, approvalMessage, rejectionMessage, appvCIMessage, approvalRole, approvalid) {
        return axios.post(`https://${host}:9001/api/finalEntCSApproval`, {
            series: series,
            approvalStatus: approvalStatus,
            approvalMessage: approvalMessage,
            rejectionMessage: rejectionMessage,
            appvCIMessage: appvCIMessage,
            approvalRole: approvalRole,
            approvalid: approvalid,
        });
    },
    finalMGMTAppv(series, approvalStatus, mgmtApprovalMessage, mgmtRejectionMessage, approvalRole, approvalid) {
        return axios.post(`https://${host}:9001/api/finalMGMTAppv`, {
            series: series,
            approvalStatus: approvalStatus,
            approvalMessage: mgmtApprovalMessage,
            rejectionMessage: mgmtRejectionMessage,
            approvalRole: approvalRole,
            approvalid: approvalid,
        });
    },


    // token protected routes
    getAllUser(JWTtoken) {
        return axios.get(`https://${host}:9001/api/getAllUser`, { headers: { authorization: `${JWTtoken}` } });
    },
    getAllRoles(JWTtoken) {
        return axios.get(`https://${host}:9001/api/getAllRoles`, { headers: { authorization: `${JWTtoken}` } });
    },
    getAllUserWithRoles(JWTtoken) {
        return axios.get(`https://${host}:9001/api/getAllUserWithRoles`, { headers: { authorization: `${JWTtoken}` } });
    },
    createNewRole(JWTtoken, userID, newRole) {
        return axios.post(`https://${host}:9001/api/createNewRole`, { userID: userID, newRole: newRole }, { headers: { authorization: `${JWTtoken}` } });
    },
    updateUserFormAccess(JWTtoken, loginID, userID, fieldName, value){
         return axios.post(`https://${host}:9001/api/updateUserFormAccess`, {loginID: loginID , userId: userID , field: fieldName, value: value },{ headers: { authorization: `${JWTtoken}`} });
    },
    createUserdataAndGrantAccess(JWTtoken, loginId, userID, userName, emaiID, blocked, newRole,
        searchTeamleader, searchBranchHead, searchExportCompliance, searchRegionBusinessHead,
        searchCreditInsurance, searchBusinessFinance) {
        return axios.post(`https://${host}:9001/api/createUserdataAndGrantAccess`, {
            loggedInID: loginId,
            userID: userID,
            userName: userName,
            emaiID: emaiID,
            blocked: blocked,
            newRole: newRole,
            Teamleader: searchTeamleader,
            BranchHead: searchBranchHead,
            ExportCompliance: searchExportCompliance,
            RegionBusinessHead: searchRegionBusinessHead,
            CreditInsurance: searchCreditInsurance,
            BusinessFinance: searchBusinessFinance
        }, { headers: { authorization: `${JWTtoken}` } });
    },
    createSalepersonMasterData(JWTtoken, searchEmpId, searchEmpName, searchEmpEmail, searchTeamleaderId, searchTeamleaderName, searchTeamleaderEmail,
        searchBranchHeadId, searchBranchHeadName, searchBranchHeadEmail, searchRegionBusinessHeadId, searchRegionBusinessHeadName, searchRegionBusinessHeadEmail) {
        return axios.post(`https://${host}:9001/api/createSalepersonMasterData`, {
            searchEmpId: searchEmpId,
            searchEmpName: searchEmpName, 
            searchEmpEmail: searchEmpEmail,
            searchTeamleaderId: searchTeamleaderId,
            searchTeamleaderName: searchTeamleaderName,
            searchTeamleaderEmail: searchTeamleaderEmail,
            searchBranchHeadId: searchBranchHeadId,
            searchBranchHeadName: searchBranchHeadName,
            searchBranchHeadEmail: searchBranchHeadEmail,
            searchRegionBusinessHeadId: searchRegionBusinessHeadId,
            searchRegionBusinessHeadName: searchRegionBusinessHeadName,
            searchRegionBusinessHeadEmail: searchRegionBusinessHeadEmail

        }, { headers: { authorization: `${JWTtoken}` } })
    },
    getSalepersonMasterData(JWTtoken) {
        return axios.get(`https://${host}:9001/api/getSalepersonMasterData`, { headers: { authorization: `${JWTtoken}` } })
    },
    getAllCrmDetails(JWTtoken) {
        return axios.get(`https://${host}:9001/api/getAllCrmDetails`, { headers: { authorization: `${JWTtoken}` } });
    },
    getcrmDetails(JWTtoken, loginID, loginRole) {
        return axios.post(`https://${host}:9001/api/getcrmDetails`, { loginID: loginID, loginRole: loginRole }, { headers: { authorization: `${JWTtoken}` } });
    },
    getTenderCrmDetails(JWTtoken, loginID, loginRole) {
        return axios.post(`https://${host}:9001/api/getTenderCrmDetails`, { loginID: loginID, loginRole: loginRole }, { headers: { authorization: `${JWTtoken}` } });
    },
    getNonTenderCrmDetails(JWTtoken, loginID, loginRole) {
        return axios.post(`https://${host}:9001/api/getNonTenderCrmDetails`, { loginID: loginID, loginRole: loginRole }, { headers: { authorization: `${JWTtoken}` } });
    },
    requestedFetchingCRM(JWTtoken) {
        return axios.post(`https://${host}:9001/api/requestedFetchingCRM`, {}, { headers: { authorization: `${JWTtoken}` } });
    },
    checkOpenOppType(JWTtoken, searchTerm) {
        return axios.post(`https://${host}:9001/api/checkOpenOppType`, { crmNumber: searchTerm }, { headers: { authorization: `${JWTtoken}` } });
    },
    preloadingLogs(JWTtoken, userID, userRole) {
        return axios.post(`https://${host}:9001/api/preloadingLogs`, { userID: userID, userRole: userRole }, { headers: { authorization: `${JWTtoken}` } });
    },
    excelPreloadingList(JWTtoken) {
        return axios.get(`https://${host}:9001/api/excelPreloadingList`, { headers: { authorization: `${JWTtoken}` } });
    },
    getSalesPreloadingLogExcel(JWTtoken, userID, userRole) {
        return axios.post(`https://${host}:9001/api/getSalesPreloadingLogExcel`,{userID: userID, userRole: userRole}, { headers: { authorization: `${JWTtoken}` } });
    },
    getCostSheetLogExcelExport(JWTtoken, userID, userRole) {
        return axios.post(`https://${host}:9001/api/getCostSheetLogExcelExport`,{userID: userID, userRole: userRole}, { headers: { authorization: `${JWTtoken}` } });
    },
    getEntCostSheetLists(JWTtoken, userID, userRole) {
        return axios.get(`https://${host}:9001/api/getEntCostSheetLists`, { headers: { authorization: `${JWTtoken}` } });
    },
    fetchEntCSListData(JWTtoken) {
        return axios.get(`https://${host}:9001/api/fetchEntCSListData`, { headers: { authorization: `${JWTtoken}` } });
    },
    exportPreloadingView(JWTtoken, series, filename) {
        return axios.post(`https://${host}:9001/api/exportPreloadingView`, {filename: filename, series: series}, { headers: { authorization: `${JWTtoken}` },  responseType: 'blob', });
    },
    getApprovalStatusRecords(JWTtoken){ 
        return axios.get(`https://${host}:9001/api/getApprovalStatusRecords`,{ headers: { authorization: `${JWTtoken}` } });
    },
    getDataAgainstPreloading(JWTtoken, series) {
        return axios.post(`https://${host}:9001/api/getDataAgainstPreloading`, { series: series }, { headers: { authorization: `${JWTtoken}` } });
    },
    getappvdata(JWTtoken, series){
        return axios.post(`https://${host}:9001/api/getappvdata`, { series: series }, { headers: { authorization: `${JWTtoken}` } });
    },
    createPreloadingRecord(JWTtoken, userName, userID, userRole) {
        return axios.post(`https://${host}:9001/api/createPreloadingRecord`, { userName: userName, userID: userID, userRole: userRole }, { headers: { authorization: `${JWTtoken}` } });
    },
    checkUserValidation(JWTtoken, series) {
        return axios.post(`https://${host}:9001/api/checkUserValidation`, { series: series }, { headers: { authorization: `${JWTtoken}` } })
    },
    requestApproval(JWTtoken, series, approvalSenderEmail, approverSenderName, approvalSenderEmpId) {
        return axios.post(`https://${host}:9001/api/requestApproval`, {
            series: series,
            approvalSenderEmail: approvalSenderEmail,
            approverSenderName: approverSenderName,
            approvalSenderEmpId: approvalSenderEmpId
        }, { headers: { authorization: `${JWTtoken}` } });
    },
    checkApprovalTable(JWTtoken, series, confirmation) {
        return axios.post(`https://${host}:9001/api/checkApprovalTable`, { series: series, confirmation: confirmation }, { headers: { authorization: `${JWTtoken}` } });
    },
    postAppNotifyRequestApproval(JWTtoken, series) {
        return axios.post(`https://${host}:9001/api/postAppNotifyRequestApproval`, { formSeries: series }, { headers: { authorization: `${JWTtoken}` } });
    },
    clearApprovals(JWTtoken, series) {
        return axios.post(`https://${host}:9001/api/clearApprovals`, { series: series }, { headers: { authorization: `${JWTtoken}` } });
    },
    createCostSheetEntRecord(JWTtoken, userName, userID, userRole) {
        return axios.post(`https://${host}:9001/api/createCostSheetEntRecord`, { userName: userName, userID: userID, userRole: userRole }, { headers: { authorization: `${JWTtoken}` } });
    },
    saveFinancialTable(JWTtoken, series , rowsToSave) {
        return axios.post(`https://${host}:9001/api/saveFinancialTable`, {series: series, financialTableRows: rowsToSave}, { headers: { authorization: `${JWTtoken}`,'Content-Type': 'application/json' } });
    },
    SaveYearlyCurrency(JWTtoken,series, CurrTrans) {
        return axios.post(`https://${host}:9001/api/SaveYearlyCurrency`, {series: series, CurrTrans: CurrTrans}, { headers: { authorization: `${JWTtoken}`,'Content-Type': 'application/json' } });
    },
    getFinancialTable(JWTtoken, series){ 
        return axios.post(`https://${host}:9001/api/getFinancialTable`, { formSeries: series }, { headers: { authorization: `${JWTtoken}` } });
    },
    checkENTCSApprovalTable(JWTtoken, series, confirmation){ 
        return axios.post(`https://${host}:9001/api/checkENTCSApprovalTable`, { series: series, confirmation: confirmation }, { headers: { authorization: `${JWTtoken}` } });
    },
    requestENTCSApproval(JWTtoken, series, confirmation, approvalSenderEmail, approverSenderName, approvalSenderEmpId){ 
        return axios.post(`https://${host}:9001/api/requestENTCSApproval`, { 
            series: series,
            confirmation:confirmation,
            approvalSenderEmail: approvalSenderEmail,
            approverSenderName: approverSenderName,
            approvalSenderEmpId: approvalSenderEmpId }, { headers: { authorization: `${JWTtoken}` } });
    },
    clearENTCSApprovals(JWTtoken, series) {
        return axios.post(`https://${host}:9001/api/clearENTCSApprovals`, { series: series }, { headers: { authorization: `${JWTtoken}` } });
    },
    saveVendorPaymentTerms(JWTtoken, loginRole, vendorPaymentTermsDetails) {
        return axios.post(`https://${host}:9001/api/saveVendorPaymentTerms`, { loginRole: loginRole, vendorPaymentTermsDetails: vendorPaymentTermsDetails }, { headers: { authorization: `${JWTtoken}` } });
    },
    deleteVendorPaymentTerm(JWTtoken, loginRole, series, sequence){
        return axios.post(`https://${host}:9001/api/deleteVendorPaymentTerm`, { loginRole: loginRole, formSeries: series, sequence: sequence }, { headers: { authorization: `${JWTtoken}` } });
    },
    saveCustomerPaymentTerms(JWTtoken, loginRole,customerPaymentTermsDetails, customerPaymentTermsDecimalSting) {
        return axios.post(`https://${host}:9001/api/saveCustomerPaymentTerms`, { loginRole: loginRole,
            customerPaymentTermsDetails: customerPaymentTermsDetails
        , customerPaymentTermsDecimalSting:customerPaymentTermsDecimalSting }, { headers: { authorization: `${JWTtoken}` } });
    },
    deleteCustomerPaymentTerm(JWTtoken, loginRole, series, sequence){
        return axios.post(`https://${host}:9001/api/deleteCustomerPaymentTerm`, { loginRole: loginRole, formSeries: series, sequence: sequence }, { headers: { authorization: `${JWTtoken}` } });
    },
    getDataAgainstEntCostSheet(JWTtoken, series){
        return axios.post(`https://${host}:9001/api/getDataAgainstEntCostSheet`, { series: series }, { headers: { authorization: `${JWTtoken}` } });
    },
    getEntCostSheetLogs(JWTtoken, userID, userRole) {
        return axios.post(`https://${host}:9001/api/getEntCostSheetLogs`, { userID: userID, userRole: userRole }, { headers: { authorization: `${JWTtoken}` } });
    },
    getEntCostSheetApprovalRecords(JWTtoken){ 
        return axios.get(`https://${host}:9001/api/getEntCostSheetApprovalRecords`, { headers: { authorization: `${JWTtoken}` } });
    },
    getENTCSAppvByFormseries(JWTtoken, series){ 
        return axios.post(`https://${host}:9001/api/getENTCSAppvByFormseries`, { series: series }, { headers: { authorization: `${JWTtoken}` } });
    },
    exportEntCostSheetViewFiles(JWTtoken, series, filename) {
        return axios.post(`https://${host}:9001/api/exportEntCostSheetViewFiles`, {filename: filename, series: series}, { headers: { authorization: `${JWTtoken}` },  responseType: 'blob', });
    },
    getFunctionalHeadList(JWTtoken){
        return axios.get(`https://${host}:9001/api/getFunctionalHeadList`, { headers: { authorization: `${JWTtoken}` } });
    },
    getForexRecord(JWTtoken, Currency) {
        return axios.post(`https://${host}:9001/api/getForexRecord`, {Currency: Currency}, { headers: { authorization: `${JWTtoken}` } });
    },
    creditApprovalByPan(JWTtoken, panNumber, searchTerm, approvalAmount, series, formFlag){
        return axios.post(`https://${host}:9001/api/creditApprovalByPan`, 
            {   panNumber: panNumber, 
                crmNumber: searchTerm, 
                approvalAmount: approvalAmount, 
                formSeries: series, 
                formFlag: formFlag},
            { headers: { authorization: `${JWTtoken}` } });
    },

}

export default apiService